import React from 'react';
import SelectField from '../../../components/ui/select-field';
import { useWhatsAppConnections } from '../hooks/useWhatsAppConnections';

interface AgentSelectorProps {
  selectedAgent: string;
  onAgentChange: (agentId: string) => void;
}

const AgentSelector: React.FC<AgentSelectorProps> = ({ selectedAgent, onAgentChange }) => {
  const { connections, loading, error } = useWhatsAppConnections();

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onAgentChange(e.target.value);
  };

  if (error) {
    return (
      <div className="text-red-500 text-sm">
        Error al cargar agentes: {error}
      </div>
    );
  }

  const options = [
    { value: '', label: loading ? 'Cargando...' : 'Seleccionar agente' },
    ...connections.map(conn => ({
      value: conn.id,
      label: `${conn.nombre_instancia} (${conn.numero_telefono})`
    }))
  ];

  return (
    <SelectField
      label="Agente WhatsApp"
      name="agent"
      value={selectedAgent}
      onChange={handleChange}
      options={options}
      disabled={loading}
      className="w-80"
    />
  );
};

export default AgentSelector;
